export const ADD_PLAN = 'ADD_PLAN'
export const REPLACE_PLAN = 'REPLACE_PLAN'
export const CLEAR_PLANS = 'CLEAR_PLANS'



// WEBPACK FOOTER //
// ./src/common/store/Plans/types.js